import { useTranslation } from "react-i18next";

const TONE = {
  pending: "bg-amber-500/15 text-amber-600",
  approved: "bg-indigo-500/15 text-indigo-500",
  paid: "bg-emerald-500/15 text-emerald-600",
  cancelled: "bg-red-500/15 text-red-500",
};

// شريحة حالة المكافأة + مؤشر الاستلام: مستلمة · بانتظار الاستلام · رفض الاستلام.
export const StatusPill = ({ status, awaiting, confirmation, received }) => {
  const { t } = useTranslation();
  const rejected = confirmation === "rejected_by_employee" && !received;
  return (
    <span className="flex flex-wrap items-center gap-1">
      <span className={`rounded-full px-2 py-0.5 text-[11px] font-black ${TONE[status] || "bg-secondary"}`}
            data-testid={`bonus-status-${status}`}>
        {t(`bonus.status.${status}`)}
      </span>
      {rejected ? (
        <span className="rounded-full bg-red-500/20 px-2 py-0.5 text-[11px] font-black text-red-500"
              data-testid="bonus-rejected-pill">
          {t("bonus.rejectedPill")}
        </span>
      ) : null}
      {received ? (
        <span className="rounded-full bg-emerald-500/20 px-2 py-0.5 text-[11px] font-black text-emerald-600"
              data-testid="bonus-received-pill">
          {t("bonus.receivedPill")}
        </span>
      ) : null}
      {awaiting && !rejected ? (
        <span className="rounded-full bg-yellow-400/20 px-2 py-0.5 text-[11px] font-black text-yellow-600"
              data-testid="bonus-awaiting-pill">
          {t("bonus.awaiting")}
        </span>
      ) : null}
    </span>
  );
};
